import { useEffect, useState } from "react";

const GA_ID = "G-58PHHYR8NG";

function loadGoogleAnalytics() {
  if (window.gtag) return;

  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}');
  `;
  document.head.appendChild(script2);
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");

    if (!consent) {
      setVisible(true);
    }

    if (consent === "all") {
      loadGoogleAnalytics();
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    loadGoogleAnalytics();
    setVisible(false);
  };

  const rejectAll = () => {
    localStorage.setItem("cookie-consent", "necessary");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[420px] bg-white shadow-lg rounded-2xl p-4 z-50">
      <p className="text-sm text-gray-700 mb-4">
        Utilizamos cookies técnicas necesarias y cookies analíticas para mejorar la experiencia.
      </p>

      <div className="flex gap-2 justify-end">
        <button
          onClick={rejectAll}
          className="text-sm text-gray-600 hover:underline"
        >
          Solo necesarias
        </button>

        <button
          onClick={acceptAll}
          className="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
        >
          Aceptar todas
        </button>
      </div>
    </div>
  );
}
